import {
  useEffect, useRef, useState,
  forwardRef, useImperativeHandle, useCallback, useLayoutEffect,
} from 'react';
import useGateTooltip from 'hooks/useGateTooltip';
import SharingContext from './context';

const Canvas = ({
  children,
  canvasWidth,
  canvasHeight,
  gates,
}, ref) => {
  const canvasRef = useRef(null);
  const { tooltipRef, handleMouseMove } = useGateTooltip(gates);
  const [renderingContext, setRenderingContext] = useState(null);
  const [dataUrl, setDataUrl] = useState(null);
  const [width, setWidth] = useState(300);

  const downloadFile = useCallback(() => {
    const link = document.createElement('a');
    link.download = 'download.png';
    link.href = dataUrl;
    link.click();
    // link.delete();
  }, [dataUrl]);

  useEffect(() => {
    const canvas = canvasRef.current;
    const context2d = canvas?.getContext('2d');
    setRenderingContext(context2d);
    const dataURL = canvas?.toDataURL('image/png');
    setDataUrl(dataURL);

    const mouseMoveHandler = (event) => handleMouseMove(event, canvas);
    canvas.addEventListener('mousemove', mouseMoveHandler);

    return () => {
      canvas.removeEventListener('mousemove', mouseMoveHandler);
    };
  }, [canvasHeight, gates, handleMouseMove, renderingContext, tooltipRef, width]);

  useLayoutEffect(() => {
    const parent = canvasRef.current?.parentElement;
    const parentBoundingRect = parent?.getBoundingClientRect();
    setWidth(Math.max(canvasWidth, parentBoundingRect.width));
  }, [canvasHeight, canvasWidth, width]);

  useImperativeHandle(
    ref,
    () => ({ downloadFile }),
    [downloadFile],
  );

  return (
    <div
      className="customScrollBar"
      style={{
        width: '100%',
        overflowX: 'auto',
        textAlign: 'center',
        borderRadius: '24px',
      }}
    >
      <SharingContext.Provider value={renderingContext}>
        <canvas
          ref={canvasRef}
          width={canvasWidth}
          height={canvasHeight}
          style={{ width: `${canvasWidth / (window.devicePixelRatio || 1)}px` }}
        />
        {children}
      </SharingContext.Provider>
      <div id="chartTooltip" ref={tooltipRef} />

    </div>
  );
};

export default forwardRef(Canvas);
